// Central business information for Ardeca Construction
export const SITE = {
  name: "Ardeca Construction",
  shortName: "Ardeca",
  tagline: "Trusted Craftsmanship in Freehold & All of NJ",
  description: "Ardeca Construction is a family-owned remodeling contractor in Freehold, NJ, serving Monmouth County and all of New Jersey with licensed, insured home renovation services.",
  siteUrl: "https://ardecaconstruction.com",
  yearsExperience: "26+",
  phoneDisplay: "(908) 907-2095",
  phoneHref: "tel:+19089072095",
  email: "ardecaoffice@gmail.com",
  emailHref: "mailto:ardecaoffice@gmail.com",
  baseCity: "Freehold, New Jersey",
  county: "Monmouth County",
  hoursShort: "Open Every Day · 6 AM – 5 PM",
  hoursLong: "Monday – Sunday: 6:00 AM – 5:00 PM",
  sameAs: ["https://facebook.com/Ardecaconstructionllc", "https://www.instagram.com/ardecaconstructionllc/"],
  address: {
    streetAddress: "",
    addressLocality: "Freehold",
    addressRegion: "NJ",
    postalCode: "07728",
    addressCountry: "US",
  },
  geo: {
    latitude: 40.2587,
    longitude: -74.2749,
  },
  facebook: "https://facebook.com/Ardecaconstructionllc",
  instagram: "https://www.instagram.com/ardecaconstructionllc/",
  // Logo assets (cropped to content, served from /public)
  logoLight: "/ardeca-logo-light.png", // orange + grey CONSTRUCTION (use on light bg)
  logoDark: "/ardeca-logo-dark.png", // orange wordmark (use on dark bg)
  iconOrange: "/ardeca-icon.png",
  iconDark: "https://customer-assets.emergentagent.com/job_60e1b0dc-c657-42cb-9468-cd8fce832f79/artifacts/zt0sch73_10.png",
  iconDark: "https://customer-assets.emergentagent.com/job_60e1b0dc-c657-42cb-9468-cd8fce832f79/artifacts/zt0sch73_10.png",
};

export const COUNTIES = [
  "Monmouth County",
  "Ocean County",
  "Middlesex County",
  "Mercer County",
  "Somerset County",
  "Union County",
  "Burlington County",
  "Hunterdon County",
];

export const TOWNS = [
  "Freehold", "Marlboro", "Manalapan", "Colts Neck", "Holmdel", "Howell",
  "Red Bank", "Middletown", "Jackson", "Old Bridge", "East Brunswick",
  "Princeton", "Edison", "Toms River", "Brick", "Rumson",
];

export const TRUST_POINTS = [
  "Fully Licensed & Insured in New Jersey",
  "Family-Owned & Operated Since 1998",
  "Free, No-Pressure In-Home Estimates",
  "Transparent Pricing — No Hidden Fees",
  "Premium Materials & Manufacturer Warranties",
  "Clean, Respectful, On-Schedule Crews",
];
